import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose();

const button = enhance(({ classes, onClickAction, isFukuoka }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClickAction}
      className={classes.button}
    >
      {isFukuoka ? 'コース表示順変更' : 'メニュー表示順変更'}
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
